module.exports = __webpack_public_path__ + "img/circle_orange.9c08ea5b.svg";